<template>
  <div :class="[name]">
    <a-heading :cms="cms" :class="`${name}__heading`" />
    <component
      :is="item.component"
      v-for="item in cms.cta"
      :key="item._uid"
      v-editable="item"
      :cms="item"
      type="primary"
      :class="`${name}__cta`"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import data from '~/components/molecules/m-section-heading/m-section-header-v2.data'

export default {
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
  },
  data() {
    return {
      name: 'm-section-header-v2',
      show: false,
    }
  },
  computed: {
    ...mapGetters({
      mq: 'globals/getMq',
    }),
  },
  mounted() {
    if (this.mq.length > 0) {
      this.show = true
    }
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-section-header-v2 {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0 0 30px;

  &__heading {
    @include font-family($headings-font-family, 600);
    @include font-size(36, 40.8px);

    margin: 0 0 35px;
    letter-spacing: 1px;
  }

  &__cta {
    color: inherit;
    border-color: inherit;
    // margin-bottom: 30px;
  }
}

@include media-breakpoint-up(sm) {
  .m-section-header-v2 {
    // padding: 70px 0 30px;
    padding: 0 0 60px;
    margin-bottom: 30px;
    border-bottom: solid 1px;
    justify-content: space-between;
    align-items: center;
    flex-direction: initial;

    &__heading {
      margin: 0;
    }

    &__cta {
      margin-bottom: 0;
    }
  }
}
</style>
